import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { StyledMapModal } from './style';

export type MapModalDataType = 'farms' | 'products';

export interface MapModalProps {
  dataType: MapModalDataType;
  count: number;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const MapModal = ({
  dataType,
  count,
  open,
  onClose,
  children,
}: MapModalProps) => {
  const intl = useIntl();
  const title = intl.formatMessage(
    {
      id:
        dataType === 'products'
          ? 'map.cluster_products_title'
          : 'map.cluster_farms_title',
    },
    { count }
  );

  return (
    <StyledMapModal
      open={open}
      onCancel={onClose}
      footer={null}
      width="min(94vw, 1435px)"
      centered
      destroyOnClose
      title={title}
    >
      {children}
    </StyledMapModal>
  );
};
